import {neverland as $, render, html, useState} from 'neverland';
import { completeNewPassword } from '../lib/cognito.js';

const ConfirmPasswordPage = $(function({auth, setAuth}) {
	
	async function confirmPassword() {
		document.getElementById('error-dontmatch').classList.add('hide');
		document.getElementById('error-generic').classList.add('hide');

		let pw1 = document.getElementById('pw1').value,
			pw2 = document.getElementById('pw2').value;

		if (pw1 !== pw2) {
			document.getElementById('error-dontmatch').classList.remove('hide');
			return;
		}

		try {
			await completeNewPassword(auth.cognitoUser, pw1);
			setAuth(prevAuth => ({
				...prevAuth,
				publicPage: null,
				cognitoUser: null
			}));
		} catch(err) {
			console.warn(err);
			if (err.type === 'MFA_SETUP') {
				// Password set successfully, now need MFA setup
				setAuth(prevAuth => ({
					...prevAuth,
					publicPage: 'MFASetup',
					cognitoUser: err.user
				}));
			} else {
				document.getElementById('error-generic').classList.remove('hide');
			}
		}
	}

	function clickConfirm(event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			document.getElementById("confirm-button").click();
		}
	}

	return html`
		<div class='login-fields'>

			<label>New Password</label>
			<input id="pw1" type="password" autofocus />

			<label>Confirm New Password</label>
			<input id="pw2" type="password" onkeyup="${clickConfirm}" />

			<button id="confirm-button" onclick="${confirmPassword}">Set New Password</button>

			<div id="error-dontmatch" class="login-error hide">Passwords do not match</div>
			<div id="error-generic" class="login-error hide">Failed to set password</div>

		</div>
	`;

});

export default ConfirmPasswordPage;